import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    width: parseInt(localStorage.getItem("width") || '12') || 12,
    height: parseInt(localStorage.getItem("height") || '18') || 18,
    amountOfColors: parseInt(localStorage.getItem("amountOfColors") || '4') || 4,
    difficulty: parseInt(localStorage.getItem("difficulty") || '2') || 2,

    isContinuous: (localStorage.getItem("isContinuous") || "false").toLowerCase() === 'true',
    isFloating: (localStorage.getItem("isFloating") || "false").toLowerCase() === 'true',

  },
  mutations: {
    updateSize (state, message) {
      state.width = message.width
      state.height = message.height
      localStorage.setItem("width", state.width.toString())
      localStorage.setItem("height", state.height.toString())
    },
    updateAmountOFColors (state, message) {
      state.amountOfColors = message
      localStorage.setItem("amountOfColors", state.amountOfColors.toString())
    },
    updateDifficulty (state, message) {
      state.difficulty = message
      localStorage.setItem("difficulty", state.difficulty.toString())
    },
    updateIsContinuous (state, message) {
      state.isContinuous = message
      localStorage.setItem("isContinuous", state.isContinuous.toString())
    },
    updateIsFloating (state, message) {
      state.isFloating = message
      localStorage.setItem("isFloating", state.isFloating.toString())
    },
  },
  actions: {
  },
  modules: {
  }
})
